<template>
  <div class="input-range-form">
    <div class="label">{{ label }}</div>
    <div layout layout-align="start-end">
      <div class="input-container">
        <el-input type="number" v-model="more" @change="onChangeMore"></el-input>
      </div>
      <div class="max-label">以上</div>
      <div class="input-container">
        <el-input type="number" v-model="less" @change="onChangeLess"></el-input>
      </div>
      <div class="min-label">未満</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    label: String,
    value: {
      type: Array as PropType<unknown[]>,
      required: true
    }
  },
  data() {
    return {
      more: this.value[0],
      less: this.value[1]
    }
  },
  methods: {
    onChangeMore(val: string) {
      const more = this.convertNumber(val)

      this.$emit('input', [more, this.value[1]])

      this.more = more
    },
    onChangeLess(val: string) {
      const less = this.convertNumber(val)

      this.$emit('input', [this.value[0], less])

      this.less = less
    },
    convertNumber(val: string) {
      return val === '' ? val : Number(val) > 0 ? Number(val) : 0
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.input-range-form:not(:first-child) {
  margin-left: $spacing-unit * 3;
}

.label {
  margin-bottom: $spacing-unit;
}

.input-container {
  max-width: $spacing-unit * 16;
}

.max-label {
  margin: 0 $spacing-unit;
}

.min-label {
  margin-left: $spacing-unit;
}

:deep(.el-input__inner) {
  width: $spacing-unit * 16;
}
</style>
